module.exports = __webpack_public_path__ + "img/32_26.7d519675.png";